import * as Sentry from "@sentry/react";
import { browserTracingIntegration, captureConsoleIntegration } from "@sentry/browser";
import main from "./main";
import { VERSION } from "./version";
import { isProdHostname } from "./app/misc/isProd";

const environment = isProdHostname() ? "prod" : "dev";

Sentry.init({
  dsn: "https://e59c1d379d484463b7984a537f7d6c5f@o4504255206719488.ingest.sentry.io/4504255209930752",
  integrations: [
    browserTracingIntegration(),
    captureConsoleIntegration({
      levels: ["error"],
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.5,
  release: VERSION,
  denyUrls: ["localhost", "127.0.0.1"],
  environment,
  ignoreErrors: [
    // Transient Firebase Installations token-refresh failures; non-fatal, app continues working.
    "installations/not-registered",
    "installations/request-failed",
  ],
});

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root element");
}
main(root);
